export const memoizePromiseFn = fn => {
  const cache = new Map();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const key = JSON.stringify(args);
    if (cache.has(key)) {
      return cache.get(key);
    }
    const resultPromise = fn(...args).catch(error => {
      cache.delete(key);
      return Promise.reject(error);
    });
    cache.set(key, resultPromise);
    return resultPromise;
  };
};